<template>
    <main class="app container--row">
        <payment-successful
            :amount="formatMoney(state.amount)"
            :currency="state.currency"
            :method="state.currentMethod"
            v-if="state.currentView == 'SUCCESS_VIEW' && state.processing != true"
        />
        <payment-failed v-else-if="state.currentView == 'FAILURE_VIEW' && state.processing != true"/>
        <payment-pending
            v-else-if="state.currentView == 'PENDING_VIEW'"
        />
        <payment-timeout v-else-if="state.currentView == 'TIMEOUT_VIEW'"/>

        <template v-else>
            <payment
                class="container__col-sm-12 container__col-md-8"
                @toggle-view-payments="handleMenuChange"
                :list-of-options="state.methods"
                :options="state.methods"
                :amount="formatMoney(state.amount)"
                :currency="state.currency"
                :current-payment-option="state.currentMethod"
            />
            <navigation
                v-if="state.methods.length > 1"
                class="container__col-sm-12 container__col-md-4"
                :amount="formatMoney(state.amount)"
                :options="state.methods"
                @toggle-view-payments="handleMenuChange"
                :current-payment-option="state.currentMethod"
            />

            <div 
                v-else
                class="container__col-sm-12 container__col-md-4"
            >
                <div class="close-btn-wrapper" :class="{ 'close-btn-wrapper-single': state.methods.length === 1 }">
                    <button
                        type="button"
                        aria-label="Close Checkout"
                        @click="handleCloseIframe"
                        class="web-close-btn"
                        :class="{ hidden: !adaptStateToDevice() }"
                    >
                        <svg
                            width="46"
                            height="46"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <circle
                                cx="23"
                                cy="23"
                                r="22.629"
                                fill="#fff"
                                stroke="#DEDEDE"
                                stroke-width=".742"
                            />
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M21.586 23l-6.293-6.293a1 1 0 011.414-1.414L23 21.586l6.293-6.293a1 1 0 011.414 1.414L24.414 23l6.293 6.293a1 1 0 01-1.414 1.414L23 24.414l-6.293 6.293a1 1 0 01-1.414-1.414L21.586 23z"
                                fill="#637381"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </template>
    </main>
</template>

<script>
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import { ref, defineAsyncComponent, onMounted } from "vue";
import { formatMoney } from "./support/helpers";
import Payment from "@/components/payment";
import navigation from "@/components/layouts/navigation";

export default {
    name: "App",
    components: {
        Payment,
        navigation,
        PaymentSuccessful: defineAsyncComponent(() => /* webpackPrefetch: true */ import("@/components/common/payment-successful")),
        PaymentFailed: defineAsyncComponent(() => /* webpackPrefetch: true */ import("@/components/common/payment-failed")),
        PaymentPending: defineAsyncComponent(() => /* webpackPrefetch: true */ import("@/components/common/payment-pending")),
        PaymentTimeout: defineAsyncComponent(() => /* webpackPrefetch: true */ import("@/components/common/payment-timeout")),
    },
    setup() {
        const store = injectStore("");

        const currentView = ref(null);

        store.subscribe(() => {
            const state = store.getState();

            const newCurrentView = state.view != undefined
                ? state.view.current || null
                : null;

            if (newCurrentView && newCurrentView !== currentView.value) {
                currentView.value = newCurrentView;

                if (/_(init|bank)_view$/i.test(newCurrentView)) {
                    dispatchEvent(new CustomEvent("on:CurrentViewChange", {
                        bubbles: false,
                        cancelable: false,
                        detail: newCurrentView,
                    }));
                }
            }
        });

        function handleMenuChange(method) {
            store.PaymentMethod.switch(method);
        }

        function handleCloseIframe(state) {
            store.Control.close(state);
        }

        onMounted(() => {
            setTimeout(() => {
                import ("@/components/common/payment-successful");
                import ("@/components/common/payment-failed");
                import ("@/components/common/payment-timeout");
                import ("@/components/common/payment-pending.vue");
            }, 10000);
        });

        return {
            state: mapState({
                amount: (state) => getValueFromPath(state, "amount") || null,
                methods: (state) => getValueFromPath(state, "currency.methods") || [],
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                currentMethod: (state) =>
                    getValueFromPath(state, "method.current") || null,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
            }),
            formatMoney,
            handleCloseIframe,
            handleMenuChange,
        };
    },
};
</script>

<style lang="scss">
    .app {
        max-width: 100vw;
        height: 100vh;
        background: $white;
        overflow: scroll;
        @include screen(menner) {
            max-height: 100vh;
        }
    }

    .close-btn-wrapper {
        padding-top: 9vh;
        width: 100%;
        display: flex;
        justify-content: flex-end;

        &-single{
            justify-content: flex-start;
        }
    }

    .web-close-btn {
        display: flex;
        border: 1px solid transparent;
        justify-content: flex-end;
        margin-right: 9vw;
        padding: 0;
        margin-bottom: 1rem;
        box-sizing: border-box;
        background: inherit;
        border-radius: 50%;
        cursor: default;
        @media screen and (max-width: $breakpoint-middle - 1 * 1px) {
            display: none;
        }

        &:focus {
            border-color: #FF9B00;
            box-shadow: 0 0 0 0.05em #ffffff, 0 0 0.15em 0.1em #ff9b00;
        }
    }

// .fade-enter-active,
// .fade-leave-active {
//   transition-duration: 0.3s;
//   transition-property: opacity;
//   transition-timing-function: ease;
// }
// .fade-enter,
// .fade-leave-active {
//   opacity: 0;
// }
</style>